<div class="health-container">
  <h2>ENAC Last Pull</h2>
  <div class="controls">
    <button type="button" (click)="load()" [disabled]="loading">Reload</button>
  </div>
  <div *ngIf="loading" class="status loading">Loading...</div>
  <div *ngIf="error" class="status error">{{ error }}</div>
  <div *ngIf="!loading && !error && !hasPolled" class="status empty">No ENAC poll has run since the server started</div>
  <div *ngIf="!loading && !error && hasPolled" class="status meta">
    Polled at {{ polledAt }} &middot; {{ pollSuccess ? 'success' : 'failed' }}
    <span *ngIf="pollError"> &middot; {{ pollError }}</span>
  </div>
  <div *ngIf="!loading && !error && hasPolled && !rows.length" class="status empty">No rows returned</div>

  <table *ngIf="!loading && !error && rows.length" class="health-table">
    <thead>
      <tr>
        <th *ngFor="let col of columns">{{ col }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows">
        <td *ngFor="let col of columns">{{ row[col] }}</td>
      </tr>
    </tbody>
  </table>

  <h2>Recent ENAC Entries</h2>
  <div *ngIf="!loading && !error && recentRowsFetchedAt" class="status meta">
    Fetched at {{ recentRowsFetchedAt }}
  </div>
  <div *ngIf="!loading && recentRowsError" class="status error">{{ recentRowsError }}</div>
  <div *ngIf="!loading && !recentRowsError && !recentRows.length" class="status empty">No recent entries found</div>

  <table *ngIf="!loading && recentRows.length" class="health-table">
    <thead>
      <tr>
        <th *ngFor="let col of recentColumns">{{ col }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of recentRows">
        <td *ngFor="let col of recentColumns">{{ row[col] }}</td>
      </tr>
    </tbody>
  </table>
</div>
